import React from 'react';
import styled from 'styled-components';

import colors from 'utils/colors';
import * as Styling from 'utils/styled';

import { useSidenavContext } from '../context';
import { ISideNavContextProps } from '../interfaces';

export type ComponentProps = {
  /**
   * (Optional) custom class wrapper
   */
  className?: string;
};

type WrapperProps = Pick<ISideNavContextProps, 'isOpen'>;

const Wrapper = styled.div<WrapperProps>`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  overflow: auto;
  ${props => (props.isOpen ? Styling.fadeIn : Styling.fadeOut)}
  background-color: ${colors.darkGrey};
`;

const SideNav: React.FC<ComponentProps> = () => {
  const { isOpen, setIsOpen } = useSidenavContext();
  return <Wrapper onClick={() => setIsOpen(false)} isOpen={isOpen} />;
};

export default SideNav;
